'use client';

import { Entry, EntrySkeletonType } from 'contentful';
import React from 'react';

import { ButtonWrapper, ProductContentHousingWrapper } from './ComponentWrappers';
import FormHousing from './ComponentWrappers/FormHousing/FormHousing';

import { TypeFormHousingWithoutUnresolvableLinksResponse } from '../_generated';
import { TGeneralComponent, TReferenceTypes } from '../types/types';
import BlockQuote from '../components/BlockQuote';
import RichTextWrapper from './ComponentWrappers/RichTextWrapper';
import RelatedInsightsGeneric from '../containers/RelatedInsightsGeneric';
import HomeProductsWithDescriptionHousing from './ComponentWrappers/HomeProductsWithDescriptionHousing';

interface IContentfulGenericProps {
    mainBody?: (Entry<EntrySkeletonType, 'WITHOUT_UNRESOLVABLE_LINKS', string> | undefined)[];
}

const ContentfulGeneric: React.FC<IContentfulGenericProps> = (props) => {
    const { mainBody } = props;

    const components: TGeneralComponent[] | undefined = mainBody?.map((item) => ({
        referenceType: item?.sys.contentType.sys.id as TReferenceTypes,
        fields: item?.fields,
        componentId: item?.sys.id,
    }));

    return components?.map((component) => {
        switch (component?.referenceType) {
            case 'blockQuoteComponent': {
                return <BlockQuote key={component.componentId} component={component} />;
            }
            case 'richEditorComponent': {
                return <RichTextWrapper key={component.componentId} component={component} />;
            }
            case 'productContentHousing': {
                return (
                    <ProductContentHousingWrapper
                        component={component}
                        key={component.componentId}
                    />
                );
            }
            case 'button': {
                return <ButtonWrapper component={component} key={component.componentId} />;
            }
            case 'formHousing': {
                return (
                    <div key={component.componentId} className="tw-max-w-[500px] tw-mx-auto">
                        <FormHousing
                            formData={component as TypeFormHousingWithoutUnresolvableLinksResponse}
                            formId={component.componentId}
                        />
                    </div>
                );
            }
            case 'relatedInsights': {
                return (
                    <RelatedInsightsGeneric
                        key={component.componentId}
                        id={component.componentId}
                        paddingTop={component.fields.paddingTop}
                        paddingBottom={component.fields.paddingBottom}
                        type={component.fields.type}
                    />
                );
            }
            case 'scriptComponent': {
                return (
                    <div
                        key={component.componentId}
                        style={{ display: 'contents' }}
                        dangerouslySetInnerHTML={{ __html: component?.fields?.script }}
                    />
                );
            }
            case 'homeProductsWithDescriptionHousing': {
                return (
                    <HomeProductsWithDescriptionHousing
                        key={component.componentId}
                        component={component}
                    />
                );
            }
            default:
                return <div key={component.componentId}>{component?.fields?.title ?? ''}</div>;
        }
    });
};

export default ContentfulGeneric;
